export default {"src":"/_next/static/image/public/images/flags/flag_370.2278a1a00dc95970021d1c1c6e8d04a1.svg","height":16,"width":24};